import React from "react";
import "../caseDetail.css";

/**
 * Shown while the case request is in flight.
 *
 * The page used to render straight away against an empty object, so for
 * the length of the request you saw "Patient case card ID: undefined", a
 * broken <img> and "Invalid date" before everything popped into place.
 * This mirrors the real layout instead, so nothing shifts when the data
 * arrives.
 */
const Line = ({ w = '100%', h = 12 }) => (
  <span className="cd-skel" style={ { width: w, height: h } } />
);

const CaseDetailSkeleton = () => (
  <div className="cd-page">
    <div className="cd-hero">
      <div className="cd-hero-main">
        <span className="cd-skel cd-skel-photo" />
        <div className="cd-hero-text">
          <Line w="180px" h={ 26 } />
          <Line w="120px" h={ 14 } />
          <div className="cd-hero-meta">
            { [0, 1, 2, 3].map((i) => (
              <div className="cd-meta-item" key={ i }>
                <Line w="64px" h={ 10 } />
                <Line w="96px" h={ 14 } />
              </div>
            )) }
          </div>
        </div>
      </div>
      <div className="cd-hero-actions">
        <Line w="132px" h={ 40 } />
        <Line w="108px" h={ 40 } />
      </div>
    </div>

    { [0, 1].map((i) => (
      <div className="cd-panel" key={ i }>
        <div className="cd-panel-head"><Line w="200px" h={ 16 } /></div>
        <div className="cd-panel-body">
          <Line w="100%" h={ 12 } />
          <Line w="86%" h={ 12 } />
          <Line w="64%" h={ 12 } />
        </div>
      </div>
    )) }
  </div>
);

export default CaseDetailSkeleton;
